/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { Card, Typography, Row, Col, Flex, Avatar } from 'antd'
import {
  BankOutlined,
  CarOutlined,
  EditOutlined,
  FileOutlined,
  HomeOutlined,
  PushpinOutlined,
} from '@ant-design/icons'
import ScaleGeneralAddressModal from '~/components/DataManipulation/Scales/ScaleGeneral/ScaleGeneralAddressModal'

import { useScale } from '~/hooks/Scales/useScale'

import { translate } from '~/utils/locale'

import { EditButton } from '~/components/DefaultLayout/Buttons/buttonStyle'
import MapView from '../Map'

const ScaleGeneralForm: React.FC = () => {
  const { scaleData, isLoading, setIsEdit } = useScale()

  const { Title, Text } = Typography

  return (
    <>
      <Card
        bordered={false}
        title={<b>{translate('ScalesGeneralForm.cardTitle')}</b>}
        extra={
          <EditButton icon={<EditOutlined />} onClick={() => setIsEdit(true)}>
            Editar
          </EditButton>
        }
        style={{
          display: 'inline-block',
          width: 'calc(100% - 20px)',
        }}
      >
        <Row>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <FileOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ScalesGeneralForm.titleLabel')}
                </Title>
                <Text>{scaleData.title}</Text>
              </div>
            </Flex>
          </Col>

          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <CarOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ScalesGeneralForm.operatingRangeLabel')}
                </Title>
                {scaleData.operating_range ? (
                  <Text>{scaleData.operating_range}</Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        <Row style={{ marginTop: 14 }}>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <CarOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ScalesGeneralForm.descriptionLabel')}
                </Title>
                {scaleData.description ? (
                  <Text>{scaleData.description}</Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>
      </Card>

      <Card
        bordered={false}
        title={translate('ScalesGeneralForm.addressCardTitle')}
        extra={<ScaleGeneralAddressModal />}
        style={{
          display: 'inline-block',
          width: 'calc(100% - 20px)',
          marginTop: 14,
        }}
      >
        <Row gutter={12} style={{ marginBottom: 14 }}>
          <Col span={6}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <PushpinOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.zipcodeText')}
                </Title>
                {scaleData?.address?.zip_code ? (
                  <Text>{scaleData?.address?.zip_code}</Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <HomeOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.addressText')}
                </Title>
                {scaleData?.address ? (
                  <Text>
                    {scaleData?.address?.street}, {scaleData?.address?.number} -{' '}
                    {scaleData?.address?.neighborhood}
                  </Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
          <Col>
            <Flex gap={8}>
              <Avatar
                shape="square"
                icon={
                  <BankOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.cityText')}
                </Title>

                {scaleData?.address ? (
                  <Text>
                    {scaleData?.address?.city} - {scaleData?.address?.state}
                  </Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        {scaleData?.address ? (
          <MapView scale={scaleData} isLoading={isLoading} />
        ) : (
          ''
        )}
      </Card>
    </>
  )
}

export default ScaleGeneralForm
